import { Link } from 'react-router-dom';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { ToxnotReactComponentPaths } from '../../core/ToxnotReactComponentPaths';

import './SharedMaterialNotFound.css';

export class SharedMaterialNotFound extends ToxnotComponent<ToxnotComponentProperties> {
   
    // ===============================================================================

    public render() {
        return (
            <div className="tn-section">
                <div className="tn-section-row tn-section-heading-row">
                    <div className="tn-section-col-12">
                        <h1>{this.props.appServices.localizeString("Passport Not Found")}</h1>
                    </div>
                </div>
                <div id="shared-material-not-found-description">
                    {this.props.appServices.localizeString("Passport not found. Either this passport does not exist, or you do not have access to it.")}
                </div>
                <div>
                    <Link to={ToxnotReactComponentPaths.BaseSharedMaterialsPath}>{this.localizeString("Go to")} {this.localizeString("Passport Library")}</Link>
                </div>
            </div>
        );
    }
}